import { CSSProperties } from "react";

export const whatsappTheme: Record<string, CSSProperties> = {
  badgeStyle: {
    position: "absolute",
    top: -4,
    right: -4,
    minWidth: 22,
    height: 22,
    padding: "0 6px",
    borderRadius: 9999,
    backgroundColor: "#9ca3af",
    color: "#111827",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: "22px",
    textAlign: "center",
    boxShadow: "0 0 0 2px #ffffff",
    pointerEvents: "none"
  },
  buttonContainer: {
    position: "fixed",
    bottom: 40,
    right: 40,
    backgroundColor: "#25d366",
    color: "#FFF",
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "2px 2px 3px rgba(0,0,0,0.3)",
    zIndex: 35,
    textDecoration: "none",
    fontSize: 60 * 0.5,
    padding: 5,
    cursor: "pointer"
  },
  buttonClose: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: 24,
    lineHeight: 1,
    color: "#2c9fd5"
  },
  messageContainer: {
    position: "fixed",
    minWidth: 300,
    maxWidth: 420,
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    zIndex: 101
  },
  headerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8
  },
  messageDescription: {
    fontSize: 14,
    lineHeight: 1.35,
    color: "#929293"
  },
  messageNNoChat: {
    padding: 8,
    color: "#6b7280",
    fontSize: 13
  },
  titleStyle: {
    fontWeight: 600,
    marginBottom: 4,
    lineHeight: 1.2,
    fontSize: 16,
    color: "#7d7d7d"
  },
  headerTitleStyle: {
    fontWeight: 700,
    fontSize: 14,
    color: "#2c9fd5"
  },
  leftHeaderStyle: {
    display: "flex",
    alignItems: "center",
    gap: 8
  }
};
